<template>
  <div class="bg" v-show="show">
    <div v-show="showSelect" class="wrapper1">
      <div class="title-container">
        <p>图片编辑</p>
        <img @click="closeNotice" src="../../assets/img/common/editPicClose.svg" alt="">
      </div>
      <div style="position:relative;width: 640px;height: 360px;overflow: hidden">
        <div ref="tuiImageEditor" @mouseout="isHold=false;saveX=null;saveY=null" @mousedown="isHold=true;getTouch($event)" @mousemove="touchMove" @mouseup="isHold=false;saveX=null;saveY=null" :class="{align: scaleIndex!=100}" style="display: flex;width: 640px;height: 360px;position: absolute;top: 0;left: 0;"></div>
      </div>
      <div class="btn-container">
        <div class="left-container">
          <p @click="setMove" :class="{grey: canMove}">移动</p>
          <p @click="redo">重置</p>
        </div>
        <div class="right-container">
          <div class="btn">
            <p @click="rotateLeft">
              <img src="../../assets/img/common/rotateLeft.svg" alt="">
            </p>
            <p @click="rotateRight">
              <img src="../../assets/img/common/rotateRight.svg" alt="">
            </p>
            <p @click="cut" :class="{grey: canCut==false}">
              <img src="../../assets/img/common/cropIcon.svg" alt="">
            </p>
            <p @click="zoom('big')" :class="{grey: scaleIndex==5}">
              <img src="../../assets/img/common/zoomBig.svg" alt="">
            </p>
            <p @click="zoom('small')" :class="{grey: scaleIndex==0}">
              <img src="../../assets/img/common/zoomSmall.svg" alt="">
            </p>
          </div>
          <div class="water"></div>
        </div>
      </div>
      <div class="btns">
        <p @click="confirmEdit" class="confirm green">确定</p>
        <p @click="closeNotice" class="cancel">取消</p>
      </div>
      <!-- <div>
        <canvas id="newCanvas" width="500" height="300"></canvas>
      </div> -->
    </div>

    <div v-show="showConfirm" class="confirm-container">
      <img src="../../assets/img/common/success.png">
      <p>图片编辑成功</p>
      <span>请在多媒体库的图片列表中查看新素材</span>
      <div @click="close" class="btn">
        确认
      </div>
    </div>

    <div v-show="showFail" class="confirm-container">
      <img src="../../assets/img/common/noticeIcon.svg" alt="">
      <p>图片编辑失败</p>
      <span>{{alertWord}}请重新编辑图片</span>
      <div @click="close" class="btn">
        确认
      </div>
    </div>

    <div v-show="showNotice" class="confirm-container">
      <img src="../../assets/img/common/noticeIcon.svg" alt="">
      <p>确认离开编辑界面</p>
      <span>关闭后，编辑记录将不被保存</span>
      <div class="btns">
        <div @click="close" class="btn greenBtn">
          确认
        </div>
        <div @click="showNotice=false;showSelect=true" class="btn greyBtn">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis,websocketjs,peMiddle,fabric,tuiCodeSnippet,FileSaver,colorpicker,tuiImageEditor} from '@common/config'
import script from '../script'
// import ImageEditor from 'tui-image-editor';

export default {
  name: 'confirm',
  data() {
    return {
      pic: {
        // 图片部分数据模型
        types: [],
        assets: []
      },
      video: {
        // 视频部分数据模型
        types: [],
        assets: []
      },
      audio: {
        // 音频部分数据模型
        types: [],
        assets: []
      },
      _XN_upCfg: null,
      appId: null,
      appSecret: null,
      uploadUrl: null,
      show: true,
      selectIcons:{
        normal: require('@assets/img/common/selectIcon.svg'),
        active: require('@assets/img/common/selectIconOn.svg')
      },
      types: [
        {
          icons:{
            normal: require('@assets/img/common/smartEdit.svg'),
            active: require('@assets/img/common/smartEditOn.svg')
          },
          code: 0,
          title: ''
        },
        {
          icons:{
            normal: require('@assets/img/common/peEdit.svg'),
            active: require('@assets/img/common/peEditOn.svg')
          },
          code: 1,
          title: ''
        }
      ],
      type: {},
      toType: '',
      canSubmit: false,
      t: '',
      socket: null,
      reStartNum: 0,
      downloadPercent: '0%',
      showDownload: false,
      showConfirm: false,
      showSelect: true,
      showNotice: false,
      peData: {},
      showNoticeDetail: false,
      options: {
        cssMaxWidth: 640,
        cssMaxHeight: 360
      },
      scaleIndex: 0,
      scaleType: [1,1.2,1.4,1.6,1.8,2],
      canMove: false,
      isHold: false,
      top: 0,
      left: 0,
      saveX: null,
      saveY: null,
      actionNum: 0,
      picUrl: null,
      canCut: true,
      canEditImg: true,
      showFail: false,
      callBack: null,
      originWidth: null,
      originHeight: null,
      originWidth2: null,
      originHeight2: null,
      originMarginLeft: null,
      originMarginTop: null,
      setTopLeft: true,
      alertWord: ''
    }
  },
  methods: {
    loadfabric() {
        return common.load(fabric)
    },
    loadtuiCodeSnippet() {
        return common.load(tuiCodeSnippet)
    },
    loadFileSaver() {
        return common.load(FileSaver)
    },
    loadcolorpicker() {
        return common.load(colorpicker)
    },
    loadtuiImageEditor() {
        return common.load(tuiImageEditor)
    },
    loaded() {
      // return this.loadfabric().then(() => {
      //     return this.loadtuiCodeSnippet().then(() => {
      //         return this.loadFileSaver().then(() => {
      //           return this.loadcolorpicker().then(() => {
      //             return this.loadtuiImageEditor().then(() => {
      //               this.initPicEdit(this.picUrl)
      //             })
      //           })
      //         })
      //     })
      // })
    },
    getTouch(e) {
      this.saveX = e.screenX
      this.saveY = e.screenY
      this.$refs.tuiImageEditor.style.marginTop = 0;
      this.$refs.tuiImageEditor.style.marginLeft = 0;

      if(this.setTopLeft){
        this.setTopLeft = false;
        this.$refs.tuiImageEditor.style.top = -(this.top) + 'px'
        this.$refs.tuiImageEditor.style.left = -(this.left) + 'px'
        // this.$refs.tuiImageEditor.style.marginTop = 0;
        // this.$refs,tuiImageEditor.style.marginLeft = 0;
      }
    },
    touchMove(e) {
      if(this.canMove&&this.isHold){
        let top = this.top;
        let left = this.left;

        top = top - (e.screenY - this.saveY)
        left = left - (e.screenX - this.saveX)

        this.saveX = e.screenX
        this.saveY = e.screenY
        
        // console.log(top,left)
        this.$refs.tuiImageEditor.style.top = -top + 'px'
        this.$refs.tuiImageEditor.style.left = -left + 'px'

        this.top = top;
        this.left = left;
      }
    },
    setMove() {
      if(!this.canEditImg) return
      this.editorInstance.stopDrawingMode();
      let upperCanvas = document.getElementsByClassName('upper-canvas')
      if(!this.canMove){
        upperCanvas[0].style.display = 'none';
      }else{
        upperCanvas[0].style.display = 'block';
      }
      this.canCut = true;
      this.canMove = !this.canMove;
    },
    setCanvas() {
      let newCanvas = document.getElementById('newCanvas');
      let ctx = newCanvas.getContext("2d");

      ctx.clearRect(0,0,500,300);
      ctx.beginPath();
      // let reader = new FileReader();
      // reader.readAsDataURL(sampleImage);
      // reader.onload = function(e) {
        // let img = new Image();
        // img.src = sampleImage;
        // img.onload = function() {
        //   ctx.drawImage(img,0,0,100,50);
        //   ctx.closePath();
        //   ctx.stroke();
        // }

        // let img1 = new Image();
        // img1.src = sampleImage;
        // img1.onload = function() {
        //   ctx.drawImage(img1,200,200,100,50);
        //   ctx.closePath();
        //   ctx.stroke();
        // }
      // }
    },
    redo() {
      if(!this.canEditImg) return
      this.saveX = null
      this.saveY = null
      this.top = 0;
      this.left = 0;
      this.$refs.tuiImageEditor.style.width = 640 + 'px'
      this.$refs.tuiImageEditor.style.height = 360 + 'px'
      this.$refs.tuiImageEditor.style.top = 0 + 'px'
      this.$refs.tuiImageEditor.style.left = 0 + 'px'
      this.$refs.tuiImageEditor.style.marginTop = 0 + 'px'
      this.$refs.tuiImageEditor.style.marginLeft = 0 + 'px'
      this.scaleIndex = 0;
      this.editorInstance.destroy()
      this.initPicEdit(this.picUrl)
    },
    addImg() {
      this.editorInstance.addImageObject('https://media.smgtech.net:8443/radiodev/original/2020/07/14/393win949db4fec6a8f26c9d229b1b57b7d1611594708493445.jpg').then(objectProps => {
          console.log(objectProps);
      });
    },
    resizeEditor() {
      this.editorInstance.resizeCanvasDimension({
          width: 640,
          height: 360
      })
      this.$refs.tuiImageEditor.style.width = 640 + 'px'
      this.$refs.tuiImageEditor.style.height = 360 + 'px'
      
      let tuiDom = document.querySelector('.tui-image-editor-canvas-container');
      let lowerCanvas = document.querySelector('.lower-canvas');
      let upperCanvas = document.querySelector('.upper-canvas')
      this.originWidth = tuiDom.style.maxWidth;
      this.originHeight = tuiDom.style.maxHeight;
      
      this.$refs.tuiImageEditor.style.top = 0
      this.$refs.tuiImageEditor.style.left = 0
      this.$refs.tuiImageEditor.style.marginTop = 0 + 'px'
      this.$refs.tuiImageEditor.style.marginLeft = 0 + 'px'
      this.top = 0;
      this.left = 0;
      this.scaleIndex = 0;
    },
    zoom(type) {
      if(!this.canEditImg) return
      let scaleIndex = this.scaleIndex;
      let saveScaleIndex = this.scaleIndex;
      this.setTopLeft = true;

      if(type == 'big'){
        if(scaleIndex<5){
          ++scaleIndex;
        }
      }else{
        if(scaleIndex>0){
          --scaleIndex;
        }
      }
      
      this.scaleIndex = scaleIndex;
      let width = 640 * this.scaleType[scaleIndex]
      let height = 360 * this.scaleType[scaleIndex]
      let width1 = parseInt(this.originWidth) * this.scaleType[scaleIndex]
      let height1 = parseInt(this.originHeight) * this.scaleType[scaleIndex]
      let width2 = parseInt(this.originWidth2) * this.scaleType[scaleIndex]
      let height2 = parseInt(this.originHeight2) * this.scaleType[scaleIndex]
      this.editorInstance.resizeCanvasDimension({
          width: width,
          height: height
      })
      this.$refs.tuiImageEditor.style.width = width + 'px'
      this.$refs.tuiImageEditor.style.height = height + 'px'
      this.$refs.tuiImageEditor.style.top = '50%'
      this.$refs.tuiImageEditor.style.left = '50%'
      this.$refs.tuiImageEditor.style.marginLeft = -width/2+'px'
      this.$refs.tuiImageEditor.style.marginTop = -height/2+'px'
      this.top = (this.$refs.tuiImageEditor.getBoundingClientRect().height - 360) / 2
      this.left = (this.$refs.tuiImageEditor.getBoundingClientRect().width - 640) / 2
      this.originMarginLeft = -width/2;
      this.originMarginTop = -height/2;
      let tuiDom = document.querySelector('.tui-image-editor-canvas-container');
      let nowWidth = parseFloat(tuiDom.style.maxWidth);
      let nowHeight = parseFloat(tuiDom.style.maxHeight)
      let lowerCanvas = document.querySelector('.lower-canvas');
      let upperCanvas = document.querySelector('.upper-canvas')
      if(nowHeight>nowWidth){
        tuiDom.style.maxWidth = width2 + 'px';
        tuiDom.style.maxHeight = height2 + 'px';
        lowerCanvas.style.maxWidth = width2 + 'px';
        lowerCanvas.style.maxHeight = height2 + 'px';
        upperCanvas.style.maxWidth = width2 + 'px';
        upperCanvas.style.maxHeight = height2 + 'px';
      }else{
        tuiDom.style.maxWidth = width1 + 'px';
        tuiDom.style.maxHeight = height1 + 'px';
        lowerCanvas.style.maxWidth = width1 + 'px';
        lowerCanvas.style.maxHeight = height1 + 'px';
        upperCanvas.style.maxWidth = width1 + 'px';
        upperCanvas.style.maxHeight = height1 + 'px';
      }
      
    },
    cut() {
      if(!this.canEditImg) return
      let that = this;
      let upperCanvas = document.getElementsByClassName('upper-canvas')
      upperCanvas[0].style.display = 'block';
      this.canMove = false;
      if(this.canCut){
        this.canCut = false
        this.editorInstance.startDrawingMode('CROPPER');
        document.addEventListener('keypress', logKey)
        function logKey(e) {
          if (e.code == "Enter" || e.code == "NumpadEnter") {
            that.cutDone();
            document.removeEventListener("keypress", logKey);
          }
        }
      }else{
        this.canCut = true
        this.editorInstance.stopDrawingMode();
      }
    },
    async cutDone() {
      let actionNum = this.actionNum;
      actionNum++
      this.actionNum = actionNum;
      this.canCut = true
      this.scaleIndex = 0;
      await this.editorInstance.crop(this.editorInstance.getCropzoneRect()).then(() => {
          this.editorInstance.stopDrawingMode();
          this.resizeEditor();
      });
    },
    rotateLeft() {
      if(!this.canEditImg) return
      let actionNum = this.actionNum;
      actionNum++
      this.actionNum = actionNum;
      this.editorInstance.rotate(-90);
    },
    rotateRight() {
      if(!this.canEditImg) return
      let actionNum = this.actionNum;
      actionNum++
      this.actionNum = actionNum;
      this.editorInstance.rotate(90);
    },
    initPicEdit(url) {
      this.editorInstance = new tui.ImageEditor(this.$refs.tuiImageEditor, this.options);
      this.editorInstance.loadImageFromURL(url,'123').then(result => {
        let tuiDom = document.querySelector('.tui-image-editor-canvas-container');
        let lowerCanvas = document.querySelector('.lower-canvas');
        let upperCanvas = document.querySelector('.upper-canvas')
        let width = parseFloat(tuiDom.style.maxWidth);
        let height = parseFloat(tuiDom.style.maxHeight);
        if(width>height){
          this.originWidth = tuiDom.style.maxWidth;
          this.originHeight = tuiDom.style.maxHeight;
          this.originHeight2 = tuiDom.style.maxHeight;
          this.originWidth2 = (height/(width/height)).toFixed(0) + 'px'
        }else{
          this.originWidth2 = tuiDom.style.maxWidth;
          this.originHeight2 = tuiDom.style.maxHeight;
          this.originWidth = (height*(height/width)).toFixed(0) + 'px'
          this.originHeight = tuiDom.style.maxHeight;
        }
        console.log(this.originWidth2,this.originHeight2)
        // this.originWidth = tuiDom.style.maxWidth;
        // this.originHeight = tuiDom.style.maxHeight;

        // console.log(tuiDom.style.maxWidth,tuiDom.style.maxHeight)
        // tuiDom.style.maxWidth = 640 + 'px';
        // tuiDom.style.maxHeight = 360 + 'px';
        // lowerCanvas.style.maxWidth = 640 + 'px';
        // lowerCanvas.style.maxHeight = 360 + 'px';
        // upperCanvas.style.maxWidth = 640 + 'px';
        // upperCanvas.style.maxHeight = 360 + 'px';
      })
    },
    loadSct() {
      // 加载js文件
      if (window.WebSocket) {
        return new Promise((r, j) => {r(true)})
      }

      return this.load(websocketjs)
    },
    load(src, type) {
      return script.load(src, type)
    },
    async open(r, t, data) {
      this.r = r
      this.t = t
      this.callBack = data
      this.show = true
      this.picUrl = t.url;
      this.getConfig();
      this.getAsperaConfig();
      this.loaded()
    },
    matchTypes(types) {
      types.forEach((i, d) => {
        i.id = i.key
        this.types.forEach(j => {
          if (j.code == i.id) {
            this.$set(j, 'title', i.title)
          }
        })
      })

      // this.type = types[0]
    },
    checkFileType(f) {
      // 检查文件类型
      let type = ''
      // let ext = f.name.split('.').pop() || f.path.split('.').pop()

      let ext = f.split('.').pop()

      ext = ext.toLowerCase()

      if (this.peData.file_format.image.indexOf(ext) > -1) {
        type = 1
      } else if (this.peData.file_format.video.indexOf(ext) > -1) {
        type = 2
      } else if (this.peData.file_format.audio.indexOf(ext) > -1) {
        type = 3
      }

      return type
    },
    selectType(t) {
      this.type = t;
      this.showNoticeDetail = true;
      this.canSubmit = true;
    },
    base64ToBlob(data) {
      var mimeString = '';
      var raw, uInt8Array, i, rawLength;
      var rImageType = /data:(image\/.+);base64,/;

      raw = data.replace(rImageType, function(header, imageType) {
          mimeString = imageType;

          return '';
      });

      raw = atob(raw);
      rawLength = raw.length;
      uInt8Array = new Uint8Array(rawLength); // eslint-disable-line

      for (i = 0; i < rawLength; i += 1) {
          uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], {type: mimeString});
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
      while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
          type: mime
      });
    },
    async downloadImg() {
      let imgUrl = await this.editorInstance.toDataURL();
      let info = {}
      if(this.t.t==null){
        info = {
          imgstr: imgUrl
        }
      }else{
        info = {
          imgstr: imgUrl,
          subject_id: this.t.d,
          subject_type: this.t.t
        }
      }
      let file = this.dataURLtoBlob(imgUrl)
      console.log(file)
      // console.log(this.dataURLtoBlob(imgUrl))
      // console.log(window._XN_upCfg,window._XN_appCfg)
      this.streamUpload(this.t.title,file)
      // return false
      // common.myFetch(apis.editimg,info)
      // .then(r => {
      //   console.log(r)
      //   if(r) {
      //     console.log(999)
      //     this.$imgLoading.close()
      //     this.callBack(true)
      //     this.showSelect = false;
      //     this.showConfirm = true;
      //     this.canEditImg = true
      //     this.r(123)
      //   }else{
      //     console.log(888)
      //     this.$imgLoading.close()
      //     this.showSelect = false;
      //     this.showFail = true;
      //     this.canEditImg = true
      //     this.alertWord = '网络连接超时'
      //   }
      // })
      // .catch(() => {
      //   console.log(777)
      //   this.$imgLoading.close()
      //   this.showSelect = false;
      //   this.showFail = true;
      //   this.canEditImg = true
      //   this.alertWord = '网络连接超时'
      // })
    },
    async addAssetsToPage(data) {
      console.log('更新到接口', data);
      const filelist = [];
      data.forEach(i => {
        const type = this.checkFileType(i);
        // 将文件名改为截取前40位加后缀名
        const fileName = i.pureName || i.title || i.filename || i.name || "";
        const nameParts = fileName.split(".");
        const ext = nameParts.pop();
        let nameLeft = nameParts.join(".");
        nameLeft = nameLeft.substr(0, 40);
        const filetitle = `${nameLeft}.${ext}`;

        if(!this.t.t){
          this.t.d = ''
        }

        const file = {
          type: type,
          title: filetitle,
          path: i.targetPath || i.path,
          subject_id: this.t.d || '',
          subject_type: this.t.t || ''
        };

        filelist.push(file);
      });

      const info = { file_info: JSON.stringify(filelist) };
      return common.myFetch(apis.File_add, info).then(r => {
        if (r) {
          this.$imgLoading.close()
          this.callBack(true)
          this.showSelect = false;
          this.showConfirm = true;
          this.canEditImg = true
          this.r(123)
        }else{
          this.$imgLoading.close()
          this.showSelect = false;
          this.showFail = true;
          this.canEditImg = true
          this.alertWord = '网络连接超时'
        }
      });
    },
    streamUpload(name, file) {
      var that = this;
      var upConfig = this._XN_upCfg
      var filename = name
      var uniname = common.uniKey()
      var platform = common.getPlatform()
      var ext = filename.split('.').pop()
      var fileNameId = upConfig.fileNameId
      var httpPath = upConfig.httpPath
      var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext

      const info = { 
          targetPath: path,
          appId: this.appId,
          appSecret: this.appSecret
      };

      var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
      var _xhr = new XMLHttpRequest;

      _xhr.ontimeout = function () {
          console.error('The request for ' + _url + ' timed out.');
      };

      _xhr.onreadystatechange = function() {
          console.log(_xhr.responseText)
          if (_xhr.readyState != 4 || _xhr.status < 200)
          return false;
          let data = JSON.parse(_xhr.responseText)
          if(data.success){
            console.log(data)
              data.targetPath = data.path;
              data.name = name;
              that.addAssetsToPage([data])
          }else{
            this.$imgLoading.close()
            this.showSelect = false;
            this.showFail = true;
            this.canEditImg = true
            this.alertWord = '网络连接超时'
          }
      }

      _xhr.timeout = 60 * 1000;
      _xhr.open("POST", _url, !0);
      _xhr.send(file);
    },
    getConfig() {
      return common.getFileConfigs()
      .then(r => {
        this.appId = r.app_id
        this.appSecret = r.app_secret
        this.uploadUrl = r.url
      })
    },
    getAsperaConfig() {
      // 获取aspera上传配置
      return common.myFetch(apis.File_Aspera)
      .then(r => {
        if (r) {
          const types = r.file_format;
          this.pic.types = types.image;
          this.video.types = types.video;
          this.audio.types = types.audio;

          this._XN_upCfg = {
            asperaPath: r.aspera_path,
            httpPath: r.original_path,
            fileNameId: r.filename_id
          }
        }
      })
    },
    async confirmEdit() {
      // this.showSelect = false;
      // this.showConfirm = true;
      if(!this.canEditImg) return
      this.$imgLoading.open()
      this.canEditImg = false;
      if(!this.canCut){
        await this.cutDone();
        this.downloadImg()
      }else{
        this.downloadImg()
      }
      
    },
    closeNotice() {
      if(!this.canEditImg) return
      this.showSelect = false;
      this.showNotice = true;
    },
    close() {
      this.show = false;
      this.showSelect = true;
      this.showDownload = false;
      this.showNotice = false;
      this.showConfirm = false;
      this.canEditImg = true;
    },
    confirm() {

    },
    cancel() {
      this.close()
    },
    getData() {
      const info = {
        to_type: this.toType
      }
      return common.myFetch(apis.editaudioconfig, info)
      .then(r => {
        if (r) {
          return r.edit_config
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .align {
    align-items:center;
    justify-content: center;
  }
  .title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 18px;

    p {
      font-size: 24px;
      line-height: 32px;
      color: #050F0F;
    }

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
  .btn-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    .left-container {
      display: flex;
      flex-direction: row;

      p {
        width: 50px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid#dcdcdc;
        margin-right: 10px;
        box-sizing: border-box;
        user-select: none;
        cursor: pointer;
        font-size: 14px;
        color: #829191;

        &.grey {
          background: rgba(185,195,195,0.2);
        }
      }
    }

    .right-container {
      display: flex;
      flex-direction: row;

      .btn {
        display: flex;
        flex-direction: row;
        align-items: center;

        p {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid#dcdcdc;
          box-sizing: border-box;
          margin-right: 10px;
          cursor: pointer;

          &.grey {
            background: rgba(185,195,195,0.2);
          }
        }
      }
    }
  }
  .wrapper1 {
    padding: 20px 30px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    box-sizing: border-box;

    .cut {
      display: flex;
      width: fit-content;
      border-radius: 4px;
      border: 1px solid #CCC;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  .wrapper {
    min-height: 290px;
    width: 700px;
    padding: 20px 30px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    position: relative;
    box-sizing: border-box;
    .headline {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      p {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        // position: absolute;
        // right: 28px;
        // top: 18px;
        cursor: pointer;
      }
    }
    .types {
      display: flex;
      height: 130px;
      width: 100%;
      // padding: 0 50px;
      justify-content: space-around;
      .type {
        width: 130px;
        height: 130px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        .selector {
          width: 16px;
          height: 16px;
        }
        .con {
          width: 78px;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: @sub;
          img {
            margin-bottom: 12px;
          }
        }
      }
      .active {
        border-color: @green;
        .con {
          color: @green;
        }
      }
    }
    .notice-container {
        position: relative;
        width: 100%;
        height: 36px;
        margin: 20px 0 0;

      .smartEdit, .peEdit {
        position: absolute;
        top: 0;
        left: -30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 490px;
        height: 36px;
        background: #FFF4D0;
        border-top: 1px solid #F0C129;
        border-bottom: 1px solid #F0C129;
        padding: 0 30px;
        box-sizing: border-box; 

        div {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 15px;
            height: 14px;
            margin-right: 10px;
          }

          p {
            font-size: 14px;
            color: #E7B615;
          }

          a {
            color: @green;
            font-size: 14px;
          }
        }
      }
    }
    .btns {
      margin-top: 20px;
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .btn {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: @dateColor;
      border-radius: 25px;
      color: #FFF;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      user-select: none;
      margin-right: 20px;

      &:nth-last-of-type(1) {
        margin-right: 0;
      }

      .green {
        background: @green
      }
    }
    .confirm {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .cancel {
      background-color: @dateColor;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @dateColor;
      color: white;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }

  .download-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 590px;
    height: 136px;
    padding: 20px 30px;
    border-radius: 4px;
    background: #F9F9F9;
    box-sizing: border-box;

    span {
      font-size: 20px;
      line-height: 20px;
      color: #050F0F;
    }

    img {
      position: absolute;
      top: 20px;
      right: 30px;
      cursor: pointer;
    }

    .line {
      position: relative;
      width: 100%;
      height: 3px;
      border-radius: 1.5px;
      background: rgba(151,151,151,0.3);
      margin-top: 32px;
      overflow: hidden;

      .green {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 3px;
        border-radius: 1.5px;
        background: #41B48C;
      }
    }
  }

  .important-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    height: 240px;
    border-radius: 4px;
    background: #F9F9F9;
    padding: 40px 0 62px;
    box-sizing: border-box;

    .importantIcon {
      width: 50px;
      height: 50px;
      margin-bottom: 30px;

      img {
        width: 50px;
        height: 50px;
      }
    }

    & > img {
      position: absolute;
      top: 20px;
      right: 30px;
    }

    p {
      font-size: 20px;
      line-height: 20px;
      color: #050F0F;
      margin-bottom: 14px;
    }

    span {
      font-size: 14px;
      line-height: 14px;
      color: #829191;
    }
  }

  .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .confirm {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .cancel {
      background-color: @dateColor;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @dateColor;
      color: white;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }

    .confirm-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 400px;
      height: 290px;
      border-radius: 4px;
      background: #F9F9F9;
      padding: 40px 0;
      box-sizing: border-box;

      img {
        width: 50px;
        height: 50px;
        margin-bottom: 30px;
      }

      p {
        font-size: 20px;
        line-height: 26px;
        color: #050F0F;
        margin-bottom: 14px;
      }

      span {
        font-size: 14px;
        line-height: 18px;
        color: #829191;
        margin-bottom: 32px;
      }

      .btn {
        width: 120px;
        height: 40px;
        font-size: 14px;
        color: #41B48C;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        user-select: none;
        cursor: pointer;
      }

      .greenBtn {
        background: #41B48C;
        color: #FFF;
        margin-right: 20px;
      }

      .greyBtn {
        background: @dateColor;
        border: 1px solid @dateColor;
        color: #FFF;
        box-sizing: border-box;
      }
    }
</style>
